<template>
  <div class="tabs">
    <template v-for="(item,index) in list">
      <div class="tab  " :class="currentIndex==index?'active':''" @click="tabClick(index,item)" :key="index">
        <img :src="item.image">
        <div>{{item.title}}</div>
      </div>
    </template>
  </div>
</template>

<script>
  export default{
    props:{
      index:{
        type:Number,
        default:0
      },
      list:{
        type:Array,
        default(){
          return []
        }
      }
    },
    data(){
      return{
        currentIndex:this.index
      }
    },
    watch:{
      index(){
        this.currentIndex=this.index
      }
    },
    methods:{
      tabClick(index,item){
        this.currentIndex=index
        this.$emit("tabClick",index,item)
      }
    }
  }
</script>

<style scoped="scoped" lang="scss">
  .tabs {
    text-align: left;
    padding: 20px 20px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgb(227, 227, 227);
    color: #9f9999;

    .tab {
      margin-left: 10px;
      display: flex;
      cursor: pointer;

      img {
        margin-right: 10px;
      }
    }

    .active {
      color: #000;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/basic/FwTab.vue